// This file was auto-generated by Fern from our API Definition.
export var ChannelDestinationsQueryRequest;
(function (ChannelDestinationsQueryRequest) {
    ChannelDestinationsQueryRequest.Type = {
        Channel: "channel",
    };
})(ChannelDestinationsQueryRequest || (ChannelDestinationsQueryRequest = {}));
